module.exports = __webpack_public_path__ + "img/bny-detail-5.714601fc.png";